/**
 * Static, SEO-critical company info (NAP + socials).
 *
 * Kept as constants — NOT read from the async TenantContext — so it is present
 * in prerendered HTML even when the tenant API is unreachable at build time.
 * Mirrors the values in public/index.html and src/components/Seo.js; this is the
 * single canonical copy those should track.
 */
export const SITE = {
  name: '5 Fairies Cleaning Services',
  url: 'https://www.5fairiescleaning.com',
  telephone: '+14073152960',
  email: 'team@5fairiescleaning.com',
  ogImage: 'https://www.5fairiescleaning.com/images/og-image.jpg',
  logo: 'https://www.5fairiescleaning.com/images/logo2.jpg',
  priceRange: '$$',
  address: {
    streetAddress: '924 N Magnolia Ave, Suite 202',
    addressLocality: 'Orlando',
    addressRegion: 'FL',
    postalCode: '32803',
    addressCountry: 'US',
  },
  sameAs: [
    'https://www.facebook.com/profile.php?id=61578123928147',
    'https://www.instagram.com/5fairiescleaning',
    'https://www.linkedin.com/company/107950831/',
    'https://www.tiktok.com/@5fairiescleaning',
  ],
};

export default SITE;
